import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --cor-principal: ${({ theme }) => theme.corPrincipal || '#5a8e91'};
    --cor-secundaria: ${({ theme }) => theme.corSecundaria || '#3d6062'};
    --cor-texto: ${({ theme }) => theme.corTexto || '#F1F1F1'};
    --cor-fundo-header: ${({ theme }) => theme.corFundoHeader || '#282c34'};
    --cor-fundo-table: ${({ theme }) => theme.corFundoTable || '#24393A'};
  }

  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    background-color: var(--cor-fundo-header);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  #App-button-cor-principal-escura {
    background-color: var(--cor-secundaria); 
    border-color: var(--cor-secundaria) !important;
    color: var(--cor-texto);
    cursor: pointer;
  }

  #App-button-cor-principal {
    background-color: var(--cor-principal); 
    border-color: var(--cor-principal) !important;
    color: var(--cor-texto);
    cursor: pointer;
  }

  #App-header-table {
    background-color: var(--cor-fundo-table);
    color: var(--cor-texto);
    vertical-align: middle;
    text-align: center;
  }

  #App-header-table-esquerda {
    background-color: var(--cor-fundo-table);
    color: white;
    vertical-align: middle;
  }

  #Campo-obrigatorio,
  .campo-obrigatorio {
    background-color: #fff9c4;
    border: 1px solid #ccc;
  }

  @media (max-width: 1366px) {
    #App-reponsive-text {
      font-size: 9px;
    }
  }

  @media (min-width: 1367px) and (max-width: 1920px) {
    #App-reponsive-text {
      font-size: 12px;
    }
  }

  @keyframes single-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .animated-icon {
    display: inline-block;
    transition: transform 0.6s ease;
  }

  .animated-icon:hover {
    animation: single-spin 0.6s ease;
  }
`;

export default GlobalStyle;